// extracted by mini-css-extract-plugin
export default {"container":"HeaderInformation_container__tQk1E","groupText":"HeaderInformation_groupText__sUDOt","icon":"HeaderInformation_icon__DSib1"};